var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<div class=\"news-list__empty\">За выбранный период ничего не найдено</div>\n"}],
    template = twig({"id":"$resolved:87dc0f7def75e63df564ed26430922359fd737d52af296c8a2ed14c709f93b09de57192f559e108641959d0bb696503cd24bbeea7b2295486a67444a8a272ae5:empty.twig","data":[{"type":"raw","value":"<div class=\"news-list__empty\">За выбранный период ничего не найдено</div>\n"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;